export const NOT_AVAILABLE = "Not available";
